import {CreateForm} from "./create-form";


export const CreatePost = () => {
  return (
    <div>
      <CreateForm/>
    </div>
  )
}
